import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getRefreshToken, getToken, getTokenExpDate, setRefreshToken, signOutUser } from "src/services/localStorage";
import { updateRefreshToken } from "src/services/http/user";
import { RootReducer } from "src/redux/reducers";

interface GrifflePrivateRouteProps {
  children: React.ReactElement;
}

const GrifflePrivateRoute: React.FC<GrifflePrivateRouteProps> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const minute = 60000;

    const refreshUserToken = () => {
      if (getToken() && getRefreshToken()) {
        const expDate = getTokenExpDate();
        if (expDate) {
          const tokenDate = new Date(expDate);
          const currentDate = new Date();

          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const dateDifferenceInMinutes = Math.round((tokenDate - currentDate) / 60000);

          if (dateDifferenceInMinutes < 60) {
            updateRefreshToken({ refreshToken: getRefreshToken() })
              .then((response: any) => {
                if (response.refresh_token) {
                  setRefreshToken(response.refresh_token);
                } else {
                  signOutUser();
                  navigate("/griffle/login");
                }
              })
              .catch(() => {
                signOutUser();
                navigate("/griffle/login");
              });
          }
        }
      }
    };

    setTimeout(() => {
      refreshUserToken();
    }, 1000);

    const interval = setInterval(refreshUserToken, minute * 5);
    return () => clearInterval(interval);
  }, []); // intentional: run once on mount

  const {
    auth: { authData }
  }: RootReducer = useSelector<RootReducer>((state) => state) as RootReducer;

  if (!authData?.userId || !getToken()) {
    return <Navigate to="/griffle/login" />;
  }

  return children;
};

export default GrifflePrivateRoute;
